import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType, LoginType, RechargeType } from "../base/baseEnum";
import { LangText } from "../base/baseType";

/** 政策子项接口 */
export interface PolicySubItem {
  /** 点击参数 */
  click_params: string;
  /** 点击ID */
  click_id: number;
  /** 标题 */
  title: string;
  /** 状态 */
  status: number;
}

/** 政策项接口 */
export interface PolicyItem {
  /** 标题 */
  title: string;
  /** 状态 */
  status: number;
  /** 数据列表 */
  list: PolicySubItem[];
}

/** 政策组件属性接口 */
export interface PolicyAttrs extends BaseComponentAttrs {
  /** 数据列表 */
  list: PolicyItem[];
}

/** 政策组件类 */
export class PolicyComponent extends BaseComponent<PolicyAttrs> {
  constructor(data: Partial<BaseComponent<PolicyAttrs>> = {}) {
    super(data);
    this.type = CompType.policy;
  }
}

// 使用示例
// const policyData: Partial<BaseComponent<PolicyAttrs>> = {
//   id: "673dfebee9ec67f4a2358692",
//   type: CompType.policy,
//   variant: "",
//   title: "",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "footer_policy",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     data_list: [
//       {
//         title_lang: {
//           "1": "CONTACT US",
//           "4": "聯絡我們",
//           "11": "CONTATE-NOS",
//           "12": "CONTÁCTENOS",
//         },
//         context_lang: {},
//         key: 1732267914625,
//         data_list: [
//           {
//             title_lang: {
//               "1": "marketing@afun.com",
//               "4": "marketing@afun.com",
//               "11": "marketing@afun.com",
//               "12": "marketing@afun.com",
//             },
//             click_id: 1,
//             click_params:
//               "https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F%3Fshva%3D1&hl=zh-CN&ifkv=AcMMx-fxNoGfdsxrrv-N2QPRznj03h3PiORHUx2itw8rL2bnquSFfUN2EZlbdxY77ThPWkkoFZuQ&rip=1&sacu=1&scc=1&service=mail&flowName=GlifWebSignIn&flowEntry=ServiceLogin&dsh=S1796829705%3A1732527163157367&ddm=1",
//             key: 1732527202059,
//             status: 1,
//           },
//         ],
//         status: 1,
//       },
//     ],
//   },
// };
